export enum LotType {
  Reg = '11111111-1111-1111-1111-111111114201',
  Spec = '11111111-1111-1111-1111-111111114202',
  Model = '11111111-1111-1111-1111-111111114203'
}

export const LotTypeLabels: Record<LotType, string> = {
  [LotType.Reg]: 'Reg',
  [LotType.Spec]: 'Spec',
  [LotType.Model]: 'Model'
};
